import createStore from "./createStore";

const useIsTablet = createStore((get, set) => ({
	isTablet: window.innerWidth < 992,
	setIsTablet: (value) => set(store => ({...store, isTablet: value }))
}));

export default useIsTablet;